function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.2173 5.93211H11.7827V0.338379H11.2173V5.93211ZM11.5001 7.65325C9.47366 7.65325 7.82495 9.32621 7.82495 11.3824C7.82495 13.4386 9.47366 15.1116 11.5001 15.1116C13.5265 15.1116 15.1752 13.4386 15.1752 11.3824C15.1752 9.32621 13.5265 7.65325 11.5001 7.65325ZM11.5 15.6853C9.16182 15.6853 7.25953 13.755 7.25953 11.3824C7.25953 9.0098 9.16182 7.07954 11.5 7.07954C13.8383 7.07954 15.7405 9.0098 15.7405 11.3824C15.7405 13.755 13.8383 15.6853 11.5 15.6853ZM11.7827 16.8327V23.0001H11.2173V16.8327H11.7827ZM0.333344 11.9561H5.846V11.3824H0.333344V11.9561ZM22.6667 11.9561H16.8713V11.3824H22.6667V11.9561ZM7.48368 7.42577L3.68673 3.57299L4.08647 3.16737L7.88342 7.02016L7.48368 7.42577ZM15.5405 15.6011L19.4788 19.5974L19.8786 19.1917L15.9403 15.1955L15.5405 15.6011ZM3.8039 19.5974L3.40416 19.1917L7.05976 15.4824L7.4595 15.888L3.8039 19.5974ZM15.258 7.16359L15.6577 7.5692L19.596 3.57299L19.1963 3.16737L15.258 7.16359Z",
  fill: "#6E6E6E"
});

var SvgLowSun = function SvgLowSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLowSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/low-sun.3cab95a0.svg";
export { ForwardRef as ReactComponent };